import React from "react";
import { Button, TextField, Box, Grid, Typography, FormControl, Divider } from '@material-ui/core';
import authentication from "../../../services/authentication";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useHistory } from "react-router-dom";
import language from "../../../languages";

function SignUp(props) {
  const { classes, lang } = props
  let history  = useHistory();
  
    function handleSubmit(signUpForm) {

      const fields = {
        firstName: signUpForm.firstName,
        lastName: signUpForm.lastName,
        // username: signUpForm.username,
        emailAddress: signUpForm.email,
        password: signUpForm.password,
      }
      authentication
              .signUp(fields)
              .then((value) => {
                // props.toggleLoader(false)
                history.push('/')
              //   props.dialogProps.onClose();
              })
              .catch((reason) => {
                const code = reason.code;
                const message = reason.message;
                props.toggleLoader(false)
  
                switch (code) {
                  case "auth/email-already-in-use":
                  case "auth/invalid-email":
                  case "auth/operation-not-allowed":
                  case "auth/weak-password":
                    props.openSnackbar(message, 'error');
                    return;
  
                  default:
                    props.openSnackbar(message, 'error');
                    return;
                }
              })
              .finally(() => {
              //   this.setState({
              //     performingAction: false,
              //   });
              });
    }

    const validationSchema = Yup.object({
        // username: Yup
        //     .string()
        //     .required(language[lang].Field_Required),
        firstName: Yup
            .string()
            .required(language[lang].Field_Required),
        lastName: Yup
            .string()
            .required(language[lang].Field_Required),
        email: Yup
            .string()
            .email()
            .required(language[lang].Field_Required),
        password: Yup
            .string()
            .required(language[lang].Field_Required)
            .matches(
              "^.{6,}$",
              language[lang].Password_Criteria
            ),
        confirmPassword: Yup
            .string()
            .required(language[lang].Field_Required)
            .oneOf([Yup.ref("password"), null], language[lang].Password_Match)
    })

    const initialSignUpForm = {
        // username: '',
        firstName: '',
        lastName: '',
        email : '',
        password: '',
        confirmPassword : ''
    }

    const formik = useFormik({
        initialValues: initialSignUpForm,
        enableReinitialize:true,
        validationSchema: validationSchema || Yup.object({}),
        onSubmit: signUpForm => {
            props.toggleLoader(true)
            handleSubmit(signUpForm)
        },
    });
  
    return (
        <React.Fragment>

          <form onSubmit={formik.handleSubmit} >
          <div className={classes.root}>
            <Grid container justify="center" spacing={3}>
              <Grid item xs={12} sm={8} md={6} lg={4} className={classes.loginContainer}>
                <Box className={classes.paper} >

                  <img src={process.env.PUBLIC_URL + "avvAppLogo.png"} alt="Logo Text" className={classes.image} />
                  <Typography variant="h6" gutterBottom>{language[lang].Create_New_Account}</Typography>
                  <Typography variant="subtitle1" gutterBottom>{language[lang].Create_Request}:</Typography>
                  {/* <Grid container justify="center" alignItems="center" className={classes.inputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>Username:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='Type your Username'
                          id='username'
                          value={formik.values.username}
                          name='username'
                          type="text"
                          size="small"
                          {...formik.getFieldProps('username')}
                          error={formik.touched.username && Boolean(formik.errors.username)}
                          helperText={formik.errors.username}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid> */}
                  <Grid container justify="center" alignItems="center" className={classes.inputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].First_Name}:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='Type your first name'
                          id='firstName'
                          value={formik.values.firstName}
                          name='firstName'
                          type="text"
                          size="small"
                          {...formik.getFieldProps('firstName')}
                          error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                          helperText={formik.errors.firstName}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" alignItems="center" className={classes.signUpInputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Last_Name}:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='Type your last name'
                          id='lastName'
                          value={formik.values.lastName}
                          name='lastName'
                          type="text"
                          size="small"
                          {...formik.getFieldProps('lastName')}
                          error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                          helperText={formik.errors.lastName}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" alignItems="center" className={classes.signUpInputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Email}:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='Type your E-mail'
                          id='email'
                          value={formik.values.email}
                          name='email'
                          type="email"
                          size="small"
                          {...formik.getFieldProps('email')}
                          error={formik.touched.email && Boolean(formik.errors.email)}
                          helperText={formik.errors.email}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" alignItems="center" className={classes.signUpInputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Create_Password}:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='New password'
                          id='password'
                          value={formik.values.password}
                          name='password'
                          type="password"
                          size="small"
                          {...formik.getFieldProps('password')}
                          error={formik.touched.password && Boolean(formik.errors.password)}
                          helperText={formik.errors.password}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" alignItems="center" className={classes.signUpInputGrid}>
                    <Grid item xs={4}>   
                      <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Confirm_Password}:</Typography>
                    </Grid>
                    <Grid item xs={1} ></Grid>
                    <Grid item xs={7}>   
                        <TextField
                          className={classes.singnUpInput}
                          variant="outlined"
                          color="secondary"
                          placeholder='Confirm your new password'
                          id='confirmPassword'
                          value={formik.values.confirmPassword}
                          name='confirmPassword'
                          type="password"
                          size="small"
                          {...formik.getFieldProps('confirmPassword')}
                          error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                          helperText={formik.errors.confirmPassword}
                          onChange={formik.handleChange}
                      />
                    </Grid>
                  </Grid>


                  <Grid container justify="center" alignItems="center" className={classes.agreementText}  >
                    <Grid item xs={12}> 
                      <Typography variant="subtitle2"> {language[lang].Terms_Agree_Text} </Typography>
                    </Grid>
                    <Button size="small" className={classes.resetButton} >
                      {language[lang].Terms_of_Service}
                    </Button>
                    <Typography variant="subtitle2" > and </Typography>
                    <Button size="small" className={classes.resetButton} >
                      {language[lang].Privacy_Policy}
                    </Button>
                  </Grid>

                  <Grid container direction="row" justify="center" alignItems="center"> 
                    <Button variant="contained" size="large" type="submit" className={classes.loginButton}>
                      {language[lang].Create_Account} &nbsp; &nbsp; <ArrowForwardIosIcon fontSize="small" />
                    </Button>
                  </Grid>

                  <Grid container direction="row" justify="center" alignItems="center" className={classes.registerText}  >
                    <Typography variant="body2" > {language[lang].Have_Account} </Typography>
                    <Button size="small" className={classes.resetButton} onClick={() => history.push('/login')} >
                      {language[lang].Log_In}.
                    </Button>
                  </Grid>

                </Box>
              </Grid>
            </Grid>
          </div>
          </form>

        </React.Fragment>
    );
}

export default SignUp
